import React, { FC } from 'react';
import styled from 'styled-components';
import { GenericListColumn, SortByProps } from './GenericList';
import { Colors } from '../../styles/colors';
import { Icon } from '../general/Icon';
import { Flexbox } from '../general/Layout';

const Wrapper = styled.div`
  margin-bottom: 1rem;
  display: grid;
  padding: 0 1.5rem 0 1.5rem;
  font-weight: 700;
  min-height: 1.5rem;
`;

const IconWrapper = styled(Flexbox)``;

const SortIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  width: .75rem;
  overflow: hidden;

  margin-left: .5rem;
  :last-child {
    margin-left: .125rem;
  }

  color: ${Colors.gray};
  
  &:hover {
    cursor: pointer;
    
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
  
  &.active {
    color: ${Colors.secondary};
  }
`;

export interface GenericTableHeadProps {
  columns: GenericListColumn[];
  collapsible: boolean;
  changeSortCallback: (column: string, asc: boolean) => void;
  sortBy: SortByProps;
}

export const GenericListHead: FC<GenericTableHeadProps> = (props) => {
  const { columns, collapsible, changeSortCallback, sortBy } = props;
  return (
    <Wrapper style={{ gridTemplateColumns: `${columns.map((col) => (col.widthTemplate || '1fr')).join(' ')} ${collapsible ? '1.5rem' : ''}` }}>
      {
        columns.map((column) => {
          return (
            <div key={`column-${column.name}`}>
              <IconWrapper>
                {column.displayName}
                {
                  column.sortable &&
                  <>
                  <SortIconWrapper className={`${(sortBy.column === column.name && !sortBy.asc) ? 'active' : ''}`} onClick={() => {
                    changeSortCallback(column.name,false);
                  }}>
                    <Icon icon={'arrow-up'} size={24}/>
                  </SortIconWrapper>
                  <SortIconWrapper className={`${(sortBy.column === column.name && sortBy.asc) ? 'active' : ''}`} onClick={() => {
                    changeSortCallback(column.name,true);
                  }}>
                    <Icon icon={'arrow-down'} size={24}/>
                  </SortIconWrapper>
                  </>
                }
              </IconWrapper>
            </div>
          );
        })
      }
    </Wrapper>
  );
};
